"use client";
import Breadcrumb, { type BreadcrumbPath } from "@/app/components/breadcrumb.client";
import React from "react";
import Link from "next/link";

const policyBreadcrumbPaths: BreadcrumbPath[] = [
    { label: "Home", route: "/" },
    { label: "Legal & Regulatory" },
];

const Policy = () => {
    return (
        <section className="md:px-auto mx-auto bg-neutral-50 px-6 pb-14 pt-8 md:container md:bg-transparent md:pb-[120px] md:pt-0">
            <Breadcrumb paths={policyBreadcrumbPaths} />
            <h2 className="mb-4 text-2xl font-semibold md:mb-8 md:text-4xl">Legal & Regulatory</h2>
            <ul className="list-disc space-y-8 pl-6 text-base text-neutral-700 marker:text-neutral-700">
                <li>
                    <Link
                        href="/terms-of-use"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-secondary-500 transition-colors hover:text-secondary-600 hover:underline"
                    >
                        Terms & Conditions
                    </Link>
                </li>
                <li>
                    <Link
                        href="/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-secondary-500 transition-colors hover:text-secondary-600 hover:underline"
                    >
                        Privacy Policy
                    </Link>
                </li>
                <li>
                    <span className="text-secondary-500"></span>
                    <Link
                        href="https://marketing.incredmoney.com/Assets/webAssets/Alpha+Fintech+-+Information+Security+Governance+and+Compliance+Policy+v1.0.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-secondary-500 transition-colors hover:text-secondary-600 hover:underline"
                    >
                        Information Security Governance and Compliance Policy
                    </Link>
                </li>


                <li>
                    <Link
                    href="https://marketing.incredmoney.com/Assets/webAssets/Alpha-Fintech-User-Advisory.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-secondary-500 transition-colors hover:text-secondary-600 hover:underline"
                    >
                        Advisory for Investors
                    </Link>
               </li>

            </ul>
        </section>
    );
};

export default Policy;
